import { useQuery } from "@tanstack/react-query";
import api from "../../utils/api";

export interface ScholarshipApplication {
  id: number;
  applicationNumber: string;
  originalFileName: string;
  status: number;
  statusLabel: string;
  adminRemarks: string | null;
  submittedAt: string;
  updatedAt: string;
}

interface ScholarshipApplicationResponse {
  statusCode: number;
  message: string;
  data: ScholarshipApplication | null;
}

export const getScholarshipApplicationQueryKey = [
  "get-scholarship-application",
] as const;

const getScholarshipApplication = async () => {
  return (await api.get("/scholarship/my-application"))
    .data as ScholarshipApplicationResponse;
};

export const useGetScholarshipApplicationQuery = () => {
  const query = useQuery({
    queryKey: getScholarshipApplicationQueryKey,
    queryFn: async () => {
      try {
        return await getScholarshipApplication();
      } catch (error: any) {
        if (error?.response?.status === 404) {
          return {
            statusCode: 404,
            message: "No scholarship application found.",
            data: null,
          } as ScholarshipApplicationResponse;
        }

        throw error;
      }
    },
  });

  return {
    ...query,
    scholarshipApplication: query.data?.data,
  };
};

export default useGetScholarshipApplicationQuery;
